module.exports = __webpack_public_path__ + "images/completed-todos-ad418ce45ed798cc0d37990211ae5678.png";